import { Link } from 'react-router'
import { LuArrowRight } from 'react-icons/lu'
import { ROUTES } from '@/constants/routes'
import { Reveal } from '@/components/ui/Reveal'

export const BioScanNotes = () => (
  <section className="bg-base-50 py-16 sm:py-20">
    <div className="mx-auto max-w-5xl space-y-8 px-6">
      <Reveal>
        <div className="rounded-3xl border border-base-200 bg-white p-7 sm:p-10">
          <h2 className="mb-4 font-display text-2xl text-base-900 sm:text-3xl">Please note</h2>
          <div className="max-w-3xl space-y-4 text-base leading-7 text-base-600">
            <p>
              The standalone Bio-Scan is an assessment and feedback service. It does not include a
              full health consultation, an individualised treatment programme, herbal medicines,
              supplements or other therapeutic products.
            </p>
            <p>
              The Bio-Scan is a holistic health assessment and educational tool. It is not a
              diagnostic medical test and does not diagnose disease, confirm nutritional
              deficiencies or replace appropriate medical tests or investigations.
            </p>
          </div>
        </div>
      </Reveal>

      <Reveal>
        <div className="rounded-3xl border border-green-100 bg-green-50 p-7 sm:p-10">
          <h2 className="mb-4 font-display text-2xl text-green-900 sm:text-3xl">
            Integrated Health Consultation + Bio-Scan
          </h2>
          <p className="mb-6 max-w-3xl text-base leading-7 text-base-600">
            Bring your health history and Bio-Scan findings together in a two-hour consultation,
            followed by a comprehensive scan report, a personalised Integrated Health Report and a
            follow-up Zoom session with Kandake.
          </p>
          <Link
            to={ROUTES.SERVICES_INTEGRATED_HEALTH}
            className="inline-flex min-h-12 items-center justify-center gap-3 rounded-full bg-green-700 px-7 py-3 text-sm font-medium text-white transition-colors hover:bg-green-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-700 focus-visible:ring-offset-4"
          >
            Explore the Integrated Service
            <LuArrowRight aria-hidden="true" className="h-4 w-4 shrink-0" />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
)
